import { makeStyles } from 'lib/components';
import { IMAGE_FILES_PATH } from 'constants/AppConstants';

export default makeStyles((theme) => ({
  titleHeader: {
    minHeight: '112px',
    background: `linear-gradient(0deg, rgba(62, 100, 155, 0.80) 0%, rgba(62, 100, 155, 0.80) 100%), url(${IMAGE_FILES_PATH}/title_header_background.jpeg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '15.5px 24px',
    justifyContent: 'center',
    '@media (min-width: 640px)': {
      justifyContent: ({ breadcrumbLinks }) => (breadcrumbLinks && breadcrumbLinks.length > 0 ? 'space-between' : 'flex-end'),
    },
  },
  breadcrumbs: {
    color: theme.evPalette.salt[100],
    '& a,p': {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '20px',
      cursor: 'pointer',
    },
  },
  breadcrumbsLinks: {
    color: theme.evPalette.ocean[300],
  },
  title: {
    fontWeight: 500,
    fontSize: '30px',
    lineHeight: '41px',
    color: theme.evPalette.salt[100],
    textTransform: 'none',
    padding: '0px 0px 0px 8px',
  },
}));
